/**
 * Preferred name supersedes the full name when set (per acceptance criteria) - the full name is
 * then shown as a secondary "legal name" line under it, same as Figma (e.g. "Em" / "Emma Davis").
 */
export const getTeamMemberDisplayName = (
  firstName: string,
  lastName: string,
  preferredName?: string
): { displayName: string; legalName?: string } => {
  const legalName = `${firstName} ${lastName}`.trim();

  if (preferredName && preferredName.trim().length > 0 && preferredName.trim() !== legalName) {
    return { displayName: preferredName.trim(), legalName };
  }

  return { displayName: legalName };
};
